import { ConsultationStatus } from '@wellro/models';

export function transformConsultationStatus(value: ConsultationStatus): string {
  switch (value) {
    case ConsultationStatus.Draft:
      return 'Draft';
    case ConsultationStatus.PendingConfirmation:
      return 'Pending Confirmation';
    case ConsultationStatus.DataRejected:
      return 'Data Rejected';
    case ConsultationStatus.Cancelled:
      return 'Cancelled';
    case ConsultationStatus.Expired:
      return 'Expired';
    case ConsultationStatus.DataConfirmed:
      return 'Pending Payment';
    case ConsultationStatus.PaymentFailed:
      return 'Payment Failed';
    case ConsultationStatus.Pending:
      return 'On Doctor Queue';
    case ConsultationStatus.Ongoing:
      return 'Consulting';
    case ConsultationStatus.AwaitingPatientResponse:
      return 'Awaiting Response';
    case ConsultationStatus.Declined:
      return 'Doctor Declined';
    case ConsultationStatus.Refunded:
      return 'Patient Refunded';
    case ConsultationStatus.NewPatientData:
      return 'New Patient Data';
    case ConsultationStatus.Completed:
      return 'Consultation Completed';
    case ConsultationStatus.Closed:
      return 'Consultation Closed';
  }
}
